/** @format */

import { IAppointment } from "lobbie";
import FullScreenLoadingSpinner from "src/components/shared/loading/FullScreenLoadingSpinner";
import { isEmptyObject } from "src/utils";
import { usePatientAppointments } from "src/hooks/patients";
import PatientAppointmentCard from "./appointments/PatientAppointmentCard";

interface IProps {} // eslint-disable-line

const PatientHome: React.FC<IProps> = () => {
    const { appointments, isLoading: isLoadingAppointments } = usePatientAppointments(true);

    if (isLoadingAppointments) {
        return <FullScreenLoadingSpinner message={["Loading your appointments..."]} />;
    }

    return (
        <div className={"container"}>
            {" "}
            <div id="cy-patient-appointments" className="col">
                {isEmptyObject(appointments) ? (
                    <>
                        <hr />
                        <div className="col text-center">No Appointments Found</div>
                    </>
                ) : (
                    (appointments || [])
                        .filter((a: IAppointment) => !a.checkedOutUnix)
                        .map((appointment: IAppointment, i) => (
                            <div
                                key={appointment.id}
                                className={i === appointments.length - 1 ? "" : "border-bottom"}
                            >
                                <PatientAppointmentCard
                                    key={appointment.id}
                                    appointment={appointment}
                                />
                            </div>
                        ))
                )}
            </div>
        </div>
    );
};

export default PatientHome;
